import React, { useState } from "react";
import Dashboard from "../../components/Dashboard";
import Navbar from "../../components/Navbar";
import { useUser } from "../../context/user-context";
import { hashIcon } from "../../assets/images";
import HashIdModal from "./HashIdModal";
import ActivityBody from "./ActivityBody";
import ActivityDetailsModal from "./ActivityDetailsModal";
import TransactionDetailsModal from "./TransactionDetailsModal";

const Activities = () => {
  const { isOpen } = useUser();
  const [openHashIdModal, setOpenHashIdModal] = useState<boolean>(false);
  const [selectedTransaction, setSelectedTransaction] = useState<any>(null);
  // Two-step, matching the app: a row opens the detail view, and the receipt is
  // reached from there rather than directly.
  const [showReceipt, setShowReceipt] = useState<boolean>(false);

  const closeAll = () => {
    setShowReceipt(false);
    setSelectedTransaction(null);
  };

  return (
    <div className="lgss:flex font-manrope  lgss:flex-row h-screen lgss:h-screen bg-[#E7EBEE] dark:bg-[#13181B]">
      <Dashboard />
      {/* Column owns the height and never scrolls itself — the Navbar stays put
          and only the region below it scrolls. */}
      <div className="w-full h-full pt-0 font-manrope overflow-hidden lgss:px-0 flex flex-col justify-start item-start lgss:w-[80%]">
        <div className="shrink-0">
          <Navbar />
        </div>
        <div
          className={`w-full flex-1 min-h-0 ${
            isOpen ? "overflow-hidden" : "overflow-y-auto"
          }`}
        >
          <div className="w-full mt-10">
            <div className="w-full max-w-[720px] mx-auto px-4 mds:px-8 flex flex-col">
              <ActivityBody onSelect={setSelectedTransaction} />
            </div>
          </div>
        </div>
      </div>
      {!selectedTransaction && (
        <div className="fixed bottom-0 left-0 lgss:left-[60%] lgss:-translate-x-1/2 w-full px-4 mds:px-8 flex justify-center pointer-events-none">
          <div className="pointer-events-auto w-full max-w-[720px] rounded-t-[12px] bg-secondary_button flex justify-between items-center px-4 py-4 shadow-lg">
            <h4 className="text-white text-[12px] font-medium text-center">
              Missing or pending transaction?
            </h4>
            <button
              className="flex gap-1 items-center"
              onClick={() => setOpenHashIdModal(true)}
            >
              <img src={hashIcon} alt="hash" className="w-4 h-4" />
              <h4 className="text-white text-[12px] font-bold text-center">
                Find with Hash ID{" "}
              </h4>
            </button>
          </div>
        </div>
      )}
      {selectedTransaction && !showReceipt && (
        <TransactionDetailsModal
          transaction={selectedTransaction}
          onClose={closeAll}
          onViewReceipt={() => setShowReceipt(true)}
        />
      )}
      {selectedTransaction && showReceipt && (
        <ActivityDetailsModal
          transaction={selectedTransaction}
          // Back from the receipt returns to the detail view, not the list.
          onClose={() => setShowReceipt(false)}
        />
      )}
      {openHashIdModal && (
        <HashIdModal setOpenHashIdModal={setOpenHashIdModal} />
      )}
    </div>
  );
};

export default Activities;
